module.exports = new __parcel__URL__("RadomLogo.e62d1930.svg").toString();